export default __webpack_public_path__ + "static/media/mode-2022.fcb66cd2.svg";